import AppLayout from '@/layouts/app-layout';
import { type BreadcrumbItem } from '@/types';
import { type ReactNode } from 'react';

interface CreateLayoutProps {
    children: ReactNode;
    breadcrumbs?: BreadcrumbItem[];
    title: string;
    subtitle?: string;
}

export default function CreateLayout({ children, breadcrumbs, title, subtitle }: CreateLayoutProps) {
    return (
        <AppLayout breadcrumbs={breadcrumbs}>
            <div className="space-y-6 p-4 sm:p-6 lg:p-8">
                {/* Header */}
                <div className="space-y-2">
                    <h1 className="text-3xl font-bold tracking-tight">{title}</h1>
                    {subtitle && <p className="text-muted-foreground">{subtitle}</p>}
                </div>

                {/* Form Content */}
                <div className="max-w-4xl">{children}</div>
            </div>
        </AppLayout>
    );
}
